import {createContext} from "react";
import {strings} from "../config/strings/strings";

export const LangContext = createContext({
    lang: 'en',
    setLang: () => {},
    strings: strings,
});